import clsx from "clsx";

import type { ITypographyBaseProps } from "./types";

/**
 * This function takes in a set of typography styles as an argument, along with an optional custom class name to overriding. It then generates a CSS class name string based on the typography styles provided, which can be used to apply those styles to a corresponding HTML element. The function uses the clsx library to concatenate and format the class names in a standardized way. The generated class name string includes information about the font size, font weight, color, and display properties of the typography styles, as well as any custom class name provided.
 * @param typographySpec typography styles
 * @param className class name string to overriding
 * @returns
 */
export function generateTypographyClassName(
  typographySpec: Partial<ITypographyBaseProps>,
  className?: string,
): string {
  const {
    fontSize,
    fontType,
    fontWeight,
    themeColor,
    disableSelect,
    ellipsis,
    textWrap,
    textCenter,
  } = typographySpec;

  return clsx([
    fontSize && `fs-${fontSize}`,
    fontWeight && `fw-${fontWeight}`,
    themeColor && `color-${themeColor}`,
    fontType && `ft-${fontType}`,
    disableSelect && "disable-select",
    ellipsis && "text-overflow-ellipsis",
    textWrap && "text-wrap",
    textCenter && "text-center",
    className,
  ]);
}
